import { createFileRoute } from "@tanstack/react-router"

// Import the existing search page
import CampaignSearchPage from "@/features/jobs/search/components/campaign-search-page"

export const Route = createFileRoute("/_screen/s/campaign")({
  component: SearchCampaignPage
})

function SearchCampaignPage() {
  return <CampaignSearchPage />
}
